"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("../styles/Item.css");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
* Nom : Item.js
* Description : Ce fichier contient la définition du composant Item 
*               Ce composant est un cadre pour afficher un élément d'une liste
* Date de création : 23 septembre 2024
*/

/* CSS et assets */

/* Bibliothèques et composants */

/* Hook */
// None

/**
* Item : ce composant est un cadre pour afficher un élément d'une liste
*
* Type : composant 
*
* Parametres : 
*  - children -- contenu de l'élément à afficher
*/function Item(_ref) {
  var children = _ref.children,
    selected = _ref.selected;
  return selected === true ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "item-selected",
    children: children
  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "item-border",
    children: children
  });
}

// Les propTypes permettent de sécuriser les données en specifiant le type de donnée attendu pour une prop
Item.propTypes = {
  id: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
};
var _default = exports["default"] = Item;